module.exports = __webpack_public_path__ + "static/img/日间宣教@3x.5be75d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/日间宣教@3x.png
// module id = 313
// module chunks = 363 364